// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://cdn.syncfusion.com/ej2/material.css);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
  box-shadow: rgb(113 122 131 / 11%) 0px 7px 30px 0px;
}
.nav-item,
.navbar {
  z-index: 10000;
}
@media  screen and (max-width:800px) {
  .sidebar{
    z-index: 10000000;
  }
}

.e-dlg-center-center, .e-quick-popup-wrapper.e-device{
  z-index: 1000000 !important;
}

::-webkit-scrollbar {
  width: 6px;
}
::-webkit-scrollbar-thumb {
  background-color: rgb(216, 216, 216);
  border-radius: 40px;
}
::-webkit-scrollbar-track {
  background-color: transparent;
}

/* color-picker style  */

 #preview {
  background: transparent
    url('https://ej2.syncfusion.com/react/demos/src/color-picker/images/pen.png')
    no-repeat;
  display: inline-block;
  height: 80px;
  margin: 10px 0;
  min-width: 300px;
  max-width: 600px;
  background-color: #008000;
}

.e-input-group:not(.e-float-icon-left), .e-input-group.e-success:not(.e-float-icon-left), .e-input-group.e-warning:not(.e-float-icon-left), .e-input-group.e-error:not(.e-float-icon-left), .e-input-group.e-control-wrapper:not(.e-float-icon-left), .e-input-group.e-control-wrapper.e-success:not(.e-float-icon-left), .e-input-group.e-control-wrapper.e-warning:not(.e-float-icon-left), .e-input-group.e-control-wrapper.e-error:not(.e-float-icon-left){
  border: none;
}

#order-management-tabs {
  font-family: 'Segoe UI', Arial, sans-serif;
}

.e-tab .e-tab-header {
  font-size: 16px;
}

.e-tab .e-content {
  padding: 20px;
}

h1 {
  color: #333;
  margin-bottom: 20px;
}
.order-list {
  margin: 20px 0;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.order-list h2 {
  margin-bottom: 20px;
}

.order-list table {
  width: 100%;
  border-collapse: collapse;
}

.order-list th,
.order-list td {
  padding: 12px 16px;
  text-align: left;
}

.order-list th {
  background-color: #f3f4f6;
  font-weight: 600;
}

.order-list tr:nth-child(even) {
  background-color: #f9f9f9;
}

@media (max-width: 768px) {
  .order-list table {
    display: block;
    overflow-x: auto;
    white-space: nowrap;
  }

  .order-list th,
  .order-list td {
    display: table-cell;
    padding: 8px 12px;
  }
}
html {
  font-size: 12px; /* Default browser font size */
}
body {
  font-size: 1rem; /* Relative to html font size */
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,mDAAmD;AACrD;AACA;;EAEE,cAAc;AAChB;AACA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;AACZ;AACA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE,6BAA6B;AAC/B;;AAEA,wBAAwB;;CAEvB;EACC;;aAEW;EACX,qBAAqB;EACrB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,cAAc;IACd,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;;IAEE,mBAAmB;IACnB,iBAAiB;EACnB;AACF;AACA;EACE,eAAe,EAAE,8BAA8B;AACjD;AACA;EACE,eAAe,EAAE,+BAA+B;AAClD","sourcesContent":["@import url('https://cdn.syncfusion.com/ej2/material.css');\n\n.sidebar {\n  box-shadow: rgb(113 122 131 / 11%) 0px 7px 30px 0px;\n}\n.nav-item,\n.navbar {\n  z-index: 10000;\n}\n@media  screen and (max-width:800px) {\n  .sidebar{\n    z-index: 10000000;\n  }\n}\n\n.e-dlg-center-center, .e-quick-popup-wrapper.e-device{\n  z-index: 1000000 !important;\n}\n\n::-webkit-scrollbar {\n  width: 6px;\n}\n::-webkit-scrollbar-thumb {\n  background-color: rgb(216, 216, 216);\n  border-radius: 40px;\n}\n::-webkit-scrollbar-track {\n  background-color: transparent;\n}\n\n/* color-picker style  */\n\n #preview {\n  background: transparent\n    url('https://ej2.syncfusion.com/react/demos/src/color-picker/images/pen.png')\n    no-repeat;\n  display: inline-block;\n  height: 80px;\n  margin: 10px 0;\n  min-width: 300px;\n  max-width: 600px;\n  background-color: #008000;\n}\n\n.e-input-group:not(.e-float-icon-left), .e-input-group.e-success:not(.e-float-icon-left), .e-input-group.e-warning:not(.e-float-icon-left), .e-input-group.e-error:not(.e-float-icon-left), .e-input-group.e-control-wrapper:not(.e-float-icon-left), .e-input-group.e-control-wrapper.e-success:not(.e-float-icon-left), .e-input-group.e-control-wrapper.e-warning:not(.e-float-icon-left), .e-input-group.e-control-wrapper.e-error:not(.e-float-icon-left){\n  border: none;\n}\n\n#order-management-tabs {\n  font-family: 'Segoe UI', Arial, sans-serif;\n}\n\n.e-tab .e-tab-header {\n  font-size: 16px;\n}\n\n.e-tab .e-content {\n  padding: 20px;\n}\n\nh1 {\n  color: #333;\n  margin-bottom: 20px;\n}\n.order-list {\n  margin: 20px 0;\n  padding: 20px;\n  background-color: #f9f9f9;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.order-list h2 {\n  margin-bottom: 20px;\n}\n\n.order-list table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.order-list th,\n.order-list td {\n  padding: 12px 16px;\n  text-align: left;\n}\n\n.order-list th {\n  background-color: #f3f4f6;\n  font-weight: 600;\n}\n\n.order-list tr:nth-child(even) {\n  background-color: #f9f9f9;\n}\n\n@media (max-width: 768px) {\n  .order-list table {\n    display: block;\n    overflow-x: auto;\n    white-space: nowrap;\n  }\n\n  .order-list th,\n  .order-list td {\n    display: table-cell;\n    padding: 8px 12px;\n  }\n}\nhtml {\n  font-size: 12px; /* Default browser font size */\n}\nbody {\n  font-size: 1rem; /* Relative to html font size */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
